/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';

interface OptionTypes {
  value: number;
  label: number;
}

interface PerPageOptionsProps {
  options: Array<OptionTypes>;
  postsPerPage: number;
  handleSelect: (value: number | undefined) => void;
}

const PerPageOptions = (props: PerPageOptionsProps) => {
  const { options, postsPerPage, handleSelect } = props;
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  return (
    <div className="col-12 col-md-auto d-print-none">
      <div className="d-flex mx-0 mb-2 align-items-center">
        <label
          htmlFor="resultsPerPage"
          className="pr-2"
          style={{ paddingTop: '0.4rem', whiteSpace: 'nowrap', flexShrink: 0 }}
        >
          Mostrar
        </label>
        <div style={{ width: '90px', flexShrink: 0 }}>
          <Select
            name="resultsPerPage"
            value={{ value: postsPerPage, label: postsPerPage }}
            closeMenuOnSelect
            isDisabled={profile.in_analysis}
            onChange={(event) => handleSelect(event?.value)}
            options={options}
            styles={{
              control: (base) => ({ ...base, minHeight: 38, flexWrap: 'nowrap' }),
              valueContainer: (base) => ({
                ...base,
                flexWrap: 'nowrap',
                padding: '2px 8px',
              }),
              indicatorsContainer: (base) => ({ ...base, flexShrink: 0 }),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PerPageOptions;
